import * as exifr from "exifr/src/bundles/full.mjs"
import { fileParsers } from "exifr/src/plugins.mjs"
import { HeifFileParser } from "exifr/src/file-parsers/heif.mjs"

// Register HEIF-based format brands exifr doesn't cover out of the box — modern
// iPhones often use mif1/heix instead of heic as their compatible brand.
const extraBrands = ["mif1", "msf1", "heix", "hevc", "hevx", "heim", "heis", "hevm", "hevs"]
for (const brand of extraBrands) {
  if (!fileParsers.has(brand)) {
    class ExtraHeifParser extends HeifFileParser {
      static type = brand
      static canHandle(file, firstTwoBytes) {
        if (firstTwoBytes !== 0) return false
        let ftypLength = file.getUint16(2)
        if (ftypLength > 200) return false
        let offset = 16
        let compatibleBrands = []
        while (offset < ftypLength) {
          compatibleBrands.push(file.getString(offset, 4))
          offset += 4
        }
        return compatibleBrands.includes(brand)
      }
    }
    fileParsers.set(brand, ExtraHeifParser)
  }
}

export { exifr }

const PARSE_OPTS = {
  tiff: true, exif: true, gps: true, icc: false, iptc: false, xmp: false,
  translateValues: true, translateKeys: true, reviveValues: true,
  mergeOutput: true, chunked: false
}

// Parse a File's EXIF and return { latitude, longitude, takenAt, takenOn } when it
// has usable GPS and a date, else null. takenAt is an ISO string; takenOn is the
// YYYY-MM-DD date part. Never throws — returns null on any parse error.
export async function parseExifLocation(file) {
  try {
    const exif = await exifr.parse(file, PARSE_OPTS)
    const lat = exif?.latitude
    const lng = exif?.longitude
    if (lat == null || lng == null) return null

    const dateObj = exif?.DateTimeOriginal || exif?.CreateDate
    const takenAt = dateObj instanceof Date ? dateObj.toISOString()
      : (typeof dateObj === "string" ? new Date(dateObj).toISOString() : null)
    if (!takenAt) return null

    return { latitude: lat, longitude: lng, takenAt, takenOn: takenAt.slice(0, 10) }
  } catch (e) {
    return null
  }
}
